import { render, staticRenderFns } from "./ComparedProductListBar.vue?vue&type=template&id=21a24b28"
import script from "./ComparedProductListBar.vue?vue&type=script&lang=js"
export * from "./ComparedProductListBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports